import { render, staticRenderFns } from "./ChannelClientPermissions.vue?vue&type=template&id=6bf27442"
import script from "./ChannelClientPermissions.vue?vue&type=script&lang=js"
export * from "./ChannelClientPermissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports